import { BaseApi } from 'src/api/BaseApi';
import { DEMO_COMPANY_DATA } from 'src/api/demo/companyData';

const DEMO_CONFIG_STORE = {
  companyData: JSON.stringify(DEMO_COMPANY_DATA),
};

class ConfigApi extends BaseApi {
  async fetchConfigs(key = null) {
    if (this.isDemo()) {
      const value = DEMO_CONFIG_STORE[key] ?? null;
      return value ? { key, value } : null;
    }

    const formData = this.createFormData({ key });

    const response = await this.postRequest('server/config', formData);
    return response.data;
  }

  async submitConfig(key, value) {
    if (this.isDemo()) {
      DEMO_CONFIG_STORE[key] = value;
      return this.createDemoSuccessResponse({ key, value });
    }

    const formData = this.createFormData({ key, value });

    const response = await this.postRequest('server/config/submit', formData);
    return response.data;
  }

  async updateConfig(key, value) {
    if (this.isDemo()) {
      DEMO_CONFIG_STORE[key] = value;
      return this.createDemoSuccessResponse({ key, value });
    }

    const formData = this.createFormData({ key, value });

    const response = await this.postRequest('server/config/update', formData);
    return response.data;
  }

  async deleteConfig(key) {
    if (this.isDemo()) {
      delete DEMO_CONFIG_STORE[key];
      return this.createDemoSuccessResponse({ key, deleted: true });
    }

    const formData = this.createFormData({ key });

    const response = await this.postRequest('server/config/delete', formData);
    return response.data;
  }
}

export const configApi = new ConfigApi();
